/**
 * ============================================================
 * TRESTLE™ API Layer
 * ------------------------------------------------------------
 * Central communication layer between Shopify frontend
 * and Google Apps Script backend.
 *
 * Responsibilities
 * ----------------
 * • HTTP Communication
 * • Request Routing
 * • JSON Serialization
 * • Error Handling
 * • Authentication Requests
 * • Workspace Requests
 * • Health Requests
 * • Report Requests
 *
 * Parent Brand : Diafemme
 * Version      : 2.0
 * Status       : PRODUCTION
 * ============================================================
 */

'use strict';

const TrestleAPI = (() => {

    /*==========================================================
    Private Request Method
    ==========================================================*/

    async function post(action, data = {}) {

        try {


            console.log("API URL:", TrestleConfig.API.BASE_URL);
console.log("ACTION:", action);
console.log("PAYLOAD:", data);
            const response = await fetch(

                TrestleConfig.API.BASE_URL,

                {

                    method: "POST",

                    headers: {

                        "Content-Type": "application/json"

                    },

                    body: JSON.stringify({

                        action,

                        data

                    })

                }

            );

            if (!response.ok) {

                throw new Error(

                    "Unable to connect to TRESTLE server."

                );

            }

            return await response.json();

        }

        catch (error) {

            console.error(

                "TRESTLE API",

                error

            );

            throw error;

        }

    }

   /*==========================================================
Authentication
==========================================================*/

/**
 * ============================================================
 * Authenticates a Firebase user with optional registration data.
 *
 * @param {Object} firebaseUser
 * @param {Object} registration
 * @returns {Promise<Object>}
 * ============================================================
 */
async function authenticateUser(

    firebaseUser,

    registration = {}

) {

    return await post(

        "AUTHENTICATE",

        {

            firebaseUser,

            registration

        }

    );

}

/**
 * Registers a brand new TRESTLE user.
 */
async function registerUser(registration) {

    return await post(

        "REGISTER",

        registration

    );

}

/**
 * Validates an existing session.
 */
async function validateSession(sessionToken) {

    return await post(

        "VALIDATE_SESSION",

        {

            sessionToken

        }

    );

}

/**
 * Terminates the current session.
 */
async function logout(sessionToken) {

    return await post(

        "LOGOUT",

        {

            sessionToken

        }

    );

}

    /*==========================================================
    Workspace
    ==========================================================*/

    async function getWorkspace(userId) {

        return await post(

            "LOAD_WORKSPACE",

            {

                userId

            }

        );

    }

    /*==========================================================
    Health
    ==========================================================*/

    async function saveHealthLog(log) {

        return await post(

            "SAVE_HEALTH_LOG",

            log

        );

    }

    /*==========================================================
    Reports
    ==========================================================*/

    async function generateReport(request) {

        return await post(

            "GENERATE_REPORT",

            request

        );

    }

            /*==========================================================
        Daily Intention
        ==========================================================*/

        async function saveDailyIntention(intention) {

    return await post(

        "CREATE_DAILY_INTENTION",

        intention

    );

}

    /*==========================================================
    Public Interface
    ==========================================================*/

   return {

    authenticateUser,

    registerUser,

    validateSession,

    logout,

    getWorkspace,

    saveHealthLog,

    generateReport,

    saveDailyIntention

};

})();
window.TrestleAPI = TrestleAPI;